import { ToastService } from '@schenck/rotec-components';

// Add unique utils for Asset Manager here. Consider putting all other utils into the rotec-components library

export function onCompleteOpenSuccessfulToast(toastService: ToastService) {
  return () =>
    toastService.open({ text: 'Action successful', type: 'success', icon: 'icon-check' });
}

export function objContainsFilterStr(filterObject: any, filterString: string) {
  return Object.keys(filterObject).some((key) => {
    if (filterObject[key] && typeof filterObject[key] === 'string') {
      return filterObject[key].toLowerCase().includes(filterString.toLowerCase());
    }
  });
}
